// Lightweight i18n scaffold. Swap `dict` per locale later; t(key, fallback) is stable.
const en = {
  "nav.overview": "Overview",
  "nav.crm": "CRM",
  "nav.affiliate": "Affiliate",
  "nav.tracking": "Tracking",
  "nav.finance": "Finance",
  "nav.system": "System",
  "app.name": "Tracify",
  "app.tagline": "Affiliate Platform",
};

let locale = "en";
const dicts = { en };

export const setLocale = (l) => { locale = l; };
export const t = (key, fallback) => dicts[locale]?.[key] ?? fallback ?? key;
